import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.move');
import { OnInit, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-move',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.move/view.scss */
/* src/app/component.move/view.scss: no such file or directory */`],
})
export class ComponentMoveComponent implements OnInit, DoCheck {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public currentUrl: any;
    public first = "";
    public second = "";
    public third = "";
    public forth = "";
    public menu: any;
    public currentMenu: any;

    public userMenu = [
        { label: "대시보드", path: "dashboard", isLink: true },
        { label: "공지사항", path: "notice", isLink: true },
        { label: "기술지원", path: "support", isLink: true },
        { label: "성과", path: "research", isLink: true },
        { label: "게시판", path: "board", isLink: true },
        { label: "스토리지", path: "storage", isLink: true },
        { label: "연구그룹", path: "group", isLink: true },
        { label: "마이페이지", path: "mypage", isLink: true }
    ];

    public adminMenu = [
        { label: "사용자 관리", path: "users", isLink: true },
        { label: "승인 요청 관리", path: "request", isLink: true },
        { label: "커뮤니티 관리", path: "community", isLink: true },
        { label: "티켓팅 관리", path: "ticketing", isLink: true },
        { label: "FAQ 관리", path: "faq", isLink: true },
        { label: "매뉴얼 관리", path: "manual", isLink: true },
        { label: "성과 관리", path: "research", isLink: true },
        { label: "공지사항 관리", path: "notice", isLink: true },
        { label: "게시판 관리", path: "board", isLink: true },
        { label: "스토리지 관리", path: "storage", isLink: true },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    // =========================
    // ✅ Home 이동 (role 분기)
    // =========================
    public goHome() {
        const role = sessionStorage.getItem('role');
        if (role === 'admin') this.router.navigate(['/admin/community']);
        else this.router.navigate(['/dashboard']);
    }

    // ===========================================
    // ✅ breadcrumb 클릭 이동
    // - 'home'|'first'|'second'|'third'|'forth'
    // ===========================================
    public goCrumb(level: 'home' | 'first' | 'second' | 'third' | 'forth') {
        const url = this.router.url;
        const seg = url.split('/').filter(Boolean);
        const isAdmin = seg.includes('admin');

        // home은 role 기반으로 이동
        if (level === 'home') return this.goHome();

        // first 까지는 "메인 메뉴"로 이동
        if (level === 'first') {
            return this.navigateByFirst();
        }

        // second까지만 이동 (요청: third가 있으면 home~second까지만 이동 가능)
        if (level === 'second') {
            return this.navigateBySecond(url);
        }

        // third/forth는 선택: 필요하면 확장
        // (요구사항은 second까지 이동이 핵심이라 third/forth는 기본적으로는 이동 안해도 됨)
        if (level === 'third') {
            // 필요 시 구현
            return;
        }

        if (level === 'forth') {
            // 필요 시 구현
            return;
        }
    }

    // first 메뉴의 기본 landing 이동
    private navigateByFirst() {
        const role = sessionStorage.getItem('role');
        const isAdmin = role === 'admin';

        // 현재 first 라벨로부터 path 찾기
        const menu = isAdmin ? this.adminMenu : this.userMenu;
        const found = menu.find(m => m.label === this.first);

        if (!found) return this.goHome();

        // admin은 /admin/{path}, user는 /{path}
        if (isAdmin) this.router.navigate([`/admin/${found.path}`]);
        else this.router.navigate([`/${found.path}`]);
    }

    // second까지 이동 (현재 페이지 컨텍스트 기반으로 "목록"으로 보내기)
    private navigateBySecond(currentUrl: string) {
        const seg = currentUrl.split('/').filter(Boolean);
        const isAdmin = seg.includes('admin');

        // ===========================
        // ✅ 사용자(일반) 영역
        // ===========================
        if (!isAdmin) {
            // 기술지원
            if (this.first === '기술지원') {
                if (this.second === '티켓팅') return this.router.navigate(['/support/ticketing']);
                if (this.second === 'FAQ') return this.router.navigate(['/support/faq']);
                if (this.second === '매뉴얼') return this.router.navigate(['/support/manual']);
                return this.router.navigate(['/support']);
            }

            // 게시판: 작성/상세 -> 목록
            if (this.first === '게시판') {
                return this.router.navigate(['/board']);
            }

            // 성과: 작성/상세 -> 목록(프로젝트 구조에 맞게 조정)
            if (this.first === '성과') {
                return this.router.navigate(['/research']);
            }

            // 공지사항: 상세 -> 목록(또는 notice landing)
            if (this.first === '공지사항') {
                return this.router.navigate(['/notice']);
            }

            // 기본: first landing
            return this.navigateByFirst();
        }

        // ===========================
        // ✅ 관리자 영역
        // ===========================
        // 커뮤니티 관리의 경우: second="커뮤니티"로 잡혔으니 목록(/admin/community)로 이동
        if (this.first === '커뮤니티 관리') {
            return this.router.navigate(['/admin/community']);
        }

        // 티켓팅 관리 / FAQ 관리 등: 상세 -> 목록으로
        if (this.first === '티켓팅 관리') {
            return this.router.navigate(['/admin/ticketing']);
        }
        if (this.first === 'FAQ 관리') {
            return this.router.navigate(['/admin/faq']);
        }
        if (this.first === '공지사항 관리') {
            return this.router.navigate(['/admin/notice']);
        }
        if (this.first === '게시판 관리') {
            return this.router.navigate(['/admin/board']);
        }
        if (this.first === '스토리지 관리') {
            return this.router.navigate(['/admin/storage']);
        }
        if (this.first === '성과 관리') {
            return this.router.navigate(['/admin/research']);
        }
        if (this.first === '사용자 관리') {
            return this.router.navigate(['/admin/users']);
        }
        if (this.first === '승인 요청 관리') {
            return this.router.navigate(['/admin/request']);
        }

        // 기본: first landing
        return this.navigateByFirst();
    }

    public async ngDoCheck() {
        const url = this.router.url;
        if (this.currentUrl !== url) {
            this.currentUrl = url;

            // reset
            this.second = '';
            this.third = '';
            this.forth = '';

            let segment = url.split('/').filter(Boolean);
            const isAdmin = url.includes("admin");

            // 메뉴 세팅
            if (isAdmin) {
                this.menu = this.adminMenu;
                segment = segment.slice(1); // admin 제거
            } else {
                this.menu = this.userMenu;
            }

            // first 설정
            this.first = this.menu.find(item => url.includes(item.path))?.label || '';

            // util
            const has = (...keys: string[]) => keys.some(k => segment.includes(k));
            const isCreate = () => has('create', 'new', 'write');

            // ===== 사용자 메뉴 =====
            if (!isAdmin) {
                if (this.first === '기술지원') {
                    if (has('manual')) this.second = '매뉴얼';
                    else if (has('ticketing')) {
                        this.second = '티켓팅';

                        const idx = segment.indexOf('ticketing');
                        const tail = segment[idx + 1];

                        if (!tail) this.third = '';
                        else if (['new', 'create', 'write'].includes(tail)) this.third = '작성';
                        else this.third = '상세보기';

                    } else if (has('faq')) {
                        this.second = 'FAQ';

                        const idx = segment.indexOf('faq');
                        const tail = segment[idx + 1];

                        if (!tail) this.third = '';
                        else if (['new', 'create', 'write'].includes(tail)) this.third = '작성';
                        else this.third = '상세보기';
                    }
                } else if (this.first === '성과') {
                    this.second = isCreate() ? '작성' : '상세보기';
                } else if (this.first === '공지사항') {
                    this.second = '상세보기';
                } else if (this.first === '게시판') {
                    this.second = isCreate() ? '작성' : '상세보기';
                } else if (this.first === '연구그룹') {
                    // 필요하면 세분화
                }
            }

            // ===== 관리자 메뉴 =====
            if (isAdmin) {
                if (this.first === '커뮤니티 관리') {
                    // /admin/community/:cid/:gid/:mode 형태 대응
                    const segments = url.split('/').filter(Boolean);
                    const idx = segments.indexOf('community');
                    const after = segments.slice(idx + 1); // ['cid','gid?','mode?']

                    // 2뎁스는 공통
                    this.second = '커뮤니티';

                    const cid = after[0];
                    const maybeGroupId = after[1];
                    const isGroupContext = !isNaN(Number(maybeGroupId));

                    if (cid) {
                        if (isGroupContext) {
                            this.third = '연구그룹';
                            const mode = after[2] || 'info';
                            if (mode === 'info') this.forth = '정보';
                            else if (mode === 'user') this.forth = '연구자';
                            else if (mode === 'group') this.forth = '연구그룹';
                        } else {
                            const mode = after[1] || 'info';
                            if (mode === 'info') this.third = '정보';
                            else if (mode === 'group') this.third = '연구그룹';
                            else if (mode === 'user') this.third = '연구자';
                        }
                    }
                } else if (this.first === '티켓팅 관리') {
                    this.second = '상세보기';
                } else if (this.first === 'FAQ 관리') {
                    this.second = isCreate() ? '작성' : '상세보기';
                } else if (this.first === '공지사항 관리') {
                    this.second = isCreate() ? '작성' : '상세보기';
                } else if (this.first === '성과 관리') {
                    this.second = '상세보기';
                } else if (this.first === '사용자 관리') {
                    if (isCreate()) this.second = '신규 생성';
                } else if (this.first === '게시판 관리') {
                    this.second = '상세보기';
                }
            }

            await this.service.render();
        }
    }
}

export default ComponentMoveComponent;